export const cookieKey = {
  language: 'language',
  accessToken: 'accessToken',
  searchKeywords: 'cookie-searchKeywords',
} as const;

export type CookieObject = { -readonly [key in keyof typeof cookieKey]: string };
